import { useState } from 'react';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack, Title, Body, Divider } from '@optimus-web/core';
import { SmsUsaRegistration } from '@mews-commander/data-access';
import { RegistrationBody } from './RegistrationBody';
import { BrandRegistrationDialogForm } from './BrandRegistrationForm/BrandRegistrationDialogForm';
import { useSmsUsaBrandRegistrationAdd } from './BrandRegistrationForm/queries';

interface MessagingRegistrationProps {
    enterpriseId: string;
    smsUsaRegistration: SmsUsaRegistration;
}

export const MessagingRegistration = ({ enterpriseId, smsUsaRegistration }: MessagingRegistrationProps) => {
    const [active, setActive] = useState(false);

    const handleClose = () => {
        setActive(false);
    };

    const addBrandRegistrationMutationResult = useSmsUsaBrandRegistrationAdd({ enterpriseId, onSuccess: handleClose });

    const registrationStatus = addBrandRegistrationMutationResult.data?.status ?? smsUsaRegistration.status;

    return (
        <>
            <Stack vertical spacing="200">
                <Title level={2}>
                    <LocalizedText textKey={TextKey.RegisterToSendMessages} />
                </Title>
                <Body variant="secondary">
                    <LocalizedText textKey={TextKey.RegisterToSendMessagesExplanation} />
                </Body>
                <RegistrationBody registrationStatus={registrationStatus} setActive={setActive} />
                <Divider />
            </Stack>
            <BrandRegistrationDialogForm
                active={active}
                addBrandRegistrationMutationResult={addBrandRegistrationMutationResult}
                enterpriseId={enterpriseId}
                onClose={handleClose}
                smsUsaRegistration={smsUsaRegistration}
            />
        </>
    );
};
